<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>Ticket fixer</li>
    </ul>
  </div>
</div>
<div class="page-content overflow-y-auto px-4">
  <div class="bg-base-100 w-full max-w-7xl mx-auto p-4 border border-base-300 rounded-box flex flex-col">
    <p>Achtung. Das benutzen dieses Uploads ist SEHR gefährlich und ändert Daten sofort ohne weitere Nachfrage!</p>
    <p>
      gültige Felder: <br />
      - id (z.B: MI-20-044100)<br />
      - operation_id (z.B: 62345, INTERNE ID aus dem EXPORT!, nur pflicht, wenn unten benötigt.)<br />
      - time_estimation (z.B: 15)<br />
      - description (Ändert den Fehlertext nur im Ticket)<br />
      - description_op (Ändert den Fehlertext nurim ausgewählten Einsätz - operation_id benötigt!)<br />
      - description_all (Ändert den Fehlertext nur im Ticket und allen Einsätzen des Tickets.)<br />
      - invoice_number (Rechnungsnummer - operation_id benötigt!)<br />
      - invoice_amount (Rechnungssumme - operation_id benötigt!)<br />
      - invoice_number_partner (Rechnungsnummer Partner - operation_id benötigt!)<br />
      - invoice_amount_partner (Rechnungssumme Partner - operation_id benötigt!)<br />
      - invoice_po_order_amount (Rechnungssumme PO/Bestellung - operation_id benötigt!)<br />
      - invoice_pox_order_amount (Rechnungssumme POX/Bestellung - operation_id benötigt!)<br />
      - invoice_po15_order_amount (Rechnungssumme PO15/Bestellung - operation_id benötigt!)<br />
      - operation_date (Ändert das Datum des ausgewählten Einsatzes im Ticket - operation_id benötigt!)<br />
      - technician_ids (Ändert die Techniker des ausgewählten Einsatzes im Ticket, Ids durch | getrennt: 13|15|167|900
      oder nur 5 - operation_id benötigt!)<br />
      - status_id (ticket status id, wie vom hawk vergeben, integer)<br />
      <br /><br />

      Upload im xlsx Format<br />
      Import bricht bei erster leerer Zeile (id nicht gesetzt) ab!
    </p>

    @switch (status()) {
      @case ("new") {
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full max-w-80 self-center">
          <fieldset class="w-full">
            <input type="file" class="bm-file-input w-full" name="importfile" (change)="onFileChange($event)" />
            <button class="bm-btn bm-btn-primary bm-btn-block mt-2" type="submit">Upload</button>
          </fieldset>
        </form>
      }
      @case ("running") {
        <h3>Import läuft, bitte warten!</h3>
      }
      @case ("done") {
        <h3>Abgeschlossen!</h3>
        @if (errors()?.length) {
          <div role="alert" class="bm-alert bm-alert-error bm-alert-soft bm-alert-vertical sm:bm-alert-horizontal">
            <span></span>
            <div>
              <div class="font-bold text-lg">Fehler! (anz.: {{ errors().length }})</div>
              <div class="text-xs">
                Fehler: {{ errors() | json }}
                @for (e of errors(); track $index) {
                  <b>Zeile {{ e[0] }} </b>: Ticket {{ e[1] }}, Fehler: {{ e[2] }}<br />
                }
              </div>
            </div>
            <button class="bm-btn bm-btn-sm bm-btn-error" (click)="status.set('new')">nochmal benutzen</button>
          </div>
        }

        <button class="btn btn-primary" (click)="status.set('new')">nochmal benutzen</button>
      }
      @case ("error") {
        <div role="alert" class="bm-alert bm-alert-error bm-alert-soft bm-alert-vertical sm:bm-alert-horizontal">
          <span></span>
          <div>
            <div class="font-bold text-lg">Fehler!</div>
            <div class="text-xs">{{ errorText() }}</div>
          </div>
          <button class="bm-btn bm-btn-sm bm-btn-error" (click)="status.set('new')">nochmal benutzen</button>
        </div>
      }
    }
  </div>
</div>
